import CryptoJS from 'crypto-js/crypto-js'

/**
 * AES加密
 * @param {String} data 需加密的字符串
 * @param {String} keyStr 密钥
 */
function Encrypt (data, keyStr = 'isearchrap2020') {
  // console.log('加密 ', data)
  return data ? CryptoJS.AES.encrypt(data, keyStr).toString() : ''
}

/**
 * AES 解密
* @param {} data 需解密的字符串
 * @param {String} keyStr 密钥
 */
function Decrypt (data, keyStr = 'isearchrap2020') {
  // console.log(data)
  if (data) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, keyStr)
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8)
      if (!decryptedData) {
        return handleFailure()
      }
      return decryptedData
    } catch (error) {
      return handleFailure()
    }
  } else {
    return ''
  }
}

// 解密失败的处理
function handleFailure () {
  // 前往统一登录界面，获取token
  window.$globalHub.$store.dispatch('LogOut')
  return false
}

export default {
  Encrypt,
  Decrypt
}
